import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/auth";
import Header from "../../components/header/Header";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import PopUp from "../../components/PopUp";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import HomeIcon from "@mui/icons-material/Home";
import PhoneIcon from "@mui/icons-material/Phone";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";

const UserProfilePage = () => {
  const [auth, setAuth] = useAuth();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [currPassword, setCurrPassword] = useState("");
  const [email, setEmail] = useState("");
  const [street1, setStreet1] = useState("");
  const [street2, setStreet2] = useState("");
  const [city, setCity] = useState("");
  const [originalState, setOriginalState] = useState("");
  const [zip, setZip] = useState("");
  const [phone, setPhone] = useState("");
  const [showPopUp, setShowPopUp] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const states = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
    "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho",
    "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana",
    "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
    "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
    "New Hampshire", "New Jersey", "New Mexico", "New York",
    "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon",
    "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
    "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
    "West Virginia", "Wisconsin", "Wyoming"
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = !!auth.token;

  useEffect(() => {
    if (auth.currentUser) {
      const { name, email, address, phone } = auth.currentUser;
      setEmail(email);
      setFirstName(name.first);
      setLastName(name.last);
      setStreet1(address.street1);
      setStreet2(address.street2);
      setCity(address.city);
      setOriginalState(address.state);
      setZip(address.zip);
      setPhone(phone);
    }
  }, [auth.currentUser]);

  const apiUrl = `${process.env.REACT_APP_API}`;

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsSubmitting(true);

    const updatedData = {
      firstName,
      lastName,
      email,
      street1,
      street2,
      city,
      originalState,
      zip,
      phone,
      password,
      currPassword,
    };

    try {
      const { data } = await axios.put(`${apiUrl}/user`, updatedData);
      if (data.error) {
        console.log(data);
        toast.error(data.error);
        setIsSubmitting(false);
      } else {
        console.log(data);
        setAuth({ ...auth, user: data });
        let ls = localStorage.getItem("auth");
        ls = JSON.parse(ls);
        ls.currentUser = data;
        localStorage.setItem("auth", JSON.stringify(ls));
        toast.success("Profile Updated Successfully!");
        setIsSubmitting(false);
        setCurrPassword("");
        setPassword("");
      }
    } catch (error) {
      console.log(error);
      setIsSubmitting(false);
      if (!currPassword) {
        setShowPopUp(true);
      } else {
        toast.error("Incorrect Current Password.");
      }
    }
  };

  if (!isLoggedIn) {
    return (
        <>
          <Header />
          <div className="container my-5">
            <div className="row justify-content-center">
              <div className="col-md-6">
                <div className="card shadow-lg border-0 text-center p-5">
                  <PersonIcon style={{ fontSize: "5rem", color: "#002E6A", margin: "0 auto" }} />
                  <h3 className="mt-4 mb-3">My Profile</h3>
                  <p className="text-muted mb-4">
                    Please log in to view and edit your profile information.
                  </p>
                  <button
                      className="btn btn-lg px-5 login-button"
                      onClick={() => navigate("/login")}
                  >
                    Login to Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
    );
  }

  return (
      <>
        <Header />
        {showPopUp && (
            <PopUp
                loginButtonVisible={false}
                onCloseClick={() => {
                  setShowPopUp(false);
                }}
            >
              Please provide your current password to update your profile.
            </PopUp>
        )}

        <div className="profile-page" style={{ backgroundColor: "#f8f9fa", minHeight: "80vh" }}>
          <div className="container py-5">
            {/* Header Section */}
            <div className="text-center mb-5">
              <div className="profile-avatar mb-3">
                <PersonIcon style={{ fontSize: "5rem", color: "white" }} />
              </div>
              <h1 style={{ color: "#002E6A", fontWeight: "700" }}>
                My Profile
              </h1>
              <p className="text-muted">Manage your account information</p>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-8">
                <form onSubmit={handleSubmit}>
                  {/* Personal Information Section */}
                  <div className="card shadow-sm border-0 mb-4">
                    <div className="card-header bg-white py-3">
                      <h5 className="mb-0" style={{ color: "#002E6A", fontWeight: "600" }}>
                        <PersonIcon className="me-2" />
                        Personal Information
                      </h5>
                    </div>
                    <div className="card-body p-4">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label htmlFor="firstName" className="form-label fw-bold">
                            First Name
                          </label>
                          <input
                              type="text"
                              className="form-control form-control-lg"
                              id="firstName"
                              value={firstName}
                              onChange={(event) => setFirstName(event.target.value)}
                              required
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label htmlFor="lastName" className="form-label fw-bold">
                            Last Name
                          </label>
                          <input
                              type="text"
                              className="form-control form-control-lg"
                              id="lastName"
                              value={lastName}
                              onChange={(event) => setLastName(event.target.value)}
                              required
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label fw-bold">
                          <EmailIcon fontSize="small" className="me-1" />
                          Email Address
                        </label>
                        <input
                            type="email"
                            className="form-control form-control-lg"
                            id="email"
                            value={email}
                            readOnly
                            style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
                        />
                        <small className="text-muted">Email cannot be changed</small>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="phone" className="form-label fw-bold">
                          <PhoneIcon fontSize="small" className="me-1" />
                          Phone Number
                        </label>
                        <input
                            type="tel"
                            className="form-control form-control-lg"
                            id="phone"
                            value={phone}
                            onChange={(event) => setPhone(event.target.value)}
                            placeholder="(123) 456-7890"
                            required
                        />
                      </div>
                    </div>
                  </div>

                  {/* Password Section */}
                  <div className="card shadow-sm border-0 mb-4">
                    <div className="card-header bg-white py-3">
                      <h5 className="mb-0" style={{ color: "#002E6A", fontWeight: "600" }}>
                        <LockIcon className="me-2" />
                        Password
                      </h5>
                    </div>
                    <div className="card-body p-4">
                      <div className="alert alert-info mb-4">
                        <strong>Note:</strong> Current password is required to update any information on this page.
                      </div>
                      <div className="mb-3">
                        <label htmlFor="currPassword" className="form-label fw-bold">
                          Current Password <span className="text-danger">*</span>
                        </label>
                        <input
                            type="password"
                            className="form-control form-control-lg"
                            id="currPassword"
                            value={currPassword}
                            onChange={(event) => setCurrPassword(event.target.value)}
                            placeholder="Enter your current password"
                            required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="password" className="form-label fw-bold">
                          New Password <small className="text-muted">(Optional)</small>
                        </label>
                        <input
                            type="password"
                            className="form-control form-control-lg"
                            id="password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            placeholder="Leave blank to keep current password"
                        />
                        {password && (
                            <small className="text-muted">
                              Password should be at least 6 characters long
                            </small>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Shipping Address Section */}
                  <div className="card shadow-sm border-0 mb-4">
                    <div className="card-header bg-white py-3">
                      <h5 className="mb-0" style={{ color: "#002E6A", fontWeight: "600" }}>
                        <HomeIcon className="me-2" />
                        Shipping Address
                      </h5>
                    </div>
                    <div className="card-body p-4">
                      <div className="mb-3">
                        <label htmlFor="street1" className="form-label fw-bold">
                          Street Address
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-lg"
                            id="street1"
                            value={street1}
                            onChange={(event) => setStreet1(event.target.value)}
                            placeholder="123 Main Street"
                            required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="street2" className="form-label fw-bold">
                          Street Address 2 <small className="text-muted">(Optional)</small>
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-lg"
                            id="street2"
                            value={street2}
                            onChange={(event) => setStreet2(event.target.value)}
                            placeholder="Apartment, suite, unit, etc."
                        />
                      </div>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label htmlFor="city" className="form-label fw-bold">
                            City
                          </label>
                          <input
                              type="text"
                              className="form-control form-control-lg"
                              id="city"
                              value={city}
                              onChange={(event) => setCity(event.target.value)}
                              placeholder="City"
                              required
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="state" className="form-label fw-bold">
                            State
                          </label>
                          <select
                              className="form-select form-select-lg"
                              id="state"
                              value={originalState}
                              onChange={(event) => setOriginalState(event.target.value)}
                              required
                          >
                            <option value="">Select State</option>
                            {states.map((state) => (
                                <option key={state} value={state}>
                                  {state}
                                </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-2 mb-3">
                          <label htmlFor="zip" className="form-label fw-bold">
                            Zip Code
                          </label>
                          <input
                              type="text"
                              className="form-control form-control-lg"
                              id="zip"
                              value={zip}
                              onChange={(event) => setZip(event.target.value)}
                              placeholder="12345"
                              maxLength="5"
                              required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="text-center">
                    <button
                        type="submit"
                        className="btn btn-primary btn-lg px-5 save-button"
                        disabled={isSubmitting}
                        style={{
                          minWidth: "200px"
                        }}
                    >
                      {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Updating...
                          </>
                      ) : (
                          <>
                            <SaveIcon className="me-2" />
                            Save Changes
                          </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Footer />

        <style jsx>{`
        .profile-avatar {
          width: 120px;
          height: 120px;
          background: linear-gradient(135deg, #002e6a 0%, #c70044 100%);
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }

        .card {
          border-radius: 15px;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .card:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
        }

        .card-header {
          border-top-left-radius: 15px !important;
          border-top-right-radius: 15px !important;
          border-bottom: 2px solid #e9ecef;
        }

        .form-control:focus,
        .form-select:focus {
          border-color: #c70044;
          box-shadow: 0 0 0 0.2rem rgba(199, 0, 68, 0.25);
        }

        .form-control-lg,
        .form-select-lg {
          padding: 0.75rem 1rem;
          font-size: 1rem;
        }

        .save-button {
          background: lightcoral;
          border: none;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .save-button:hover:not(:disabled) {
          background: linear-gradient(135deg, #001a40 0%, #a00036 100%);
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(199, 0, 68, 0.4);
        }

        .save-button:disabled {
          background: #cccccc;
          cursor: not-allowed;
        }

        .login-button {
          background: linear-gradient(135deg, #002e6a 0%, #c70044 100%);
          border: none;
          color: white;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .login-button:hover {
          background: #004085;
          transform: translateY(-2px);
          
          color: white;
        }

        .alert-info {
          background-color: #e7f3ff;
          border-color: #b3d9ff;
          color: #004085;
        }

        @media (max-width: 768px) {
          .profile-avatar {
            width: 100px;
            height: 100px;
          }
        }
      `}</style>
      </>
  );
};

export default UserProfilePage;